import { render, staticRenderFns } from "./InspirationContentItem.vue?vue&type=template&id=533340cd&"
import script from "./InspirationContentItem.vue?vue&type=script&lang=js&"
export * from "./InspirationContentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports